// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container__20-UH","tabs":"main_tabs__1fMSM"};